import { atom, selector, selectorFamily } from "recoil";
import TimeController from "../components/map/helper/TimeController";

export const unificationMapTimeControllerState = atom({
  key: 'unificationMapTimeControllerState',
  default: selector({
    key: 'unificationMapTimeControllerStateSelector',
    get: () => {
      return new TimeController();
    },
    dangerouslyAllowMutability: true
  }),
  dangerouslyAllowMutability: true
});

/**
 * 平面図タイムコントローラーリスト
 */
export const mapTimeControllerListState = atom({
  key: 'mapTimeControllerListState',
  default: [],
  dangerouslyAllowMutability: true
});

/**
 * 平面図タイムコントローラーリストにタイムコントローラーを追加する
 */
export const addMapTimeControllerSelector = selector({
  key: 'addMapTimeControllerSelector',
  set: ({get, set}, timeController) => {
    const oldList = get(mapTimeControllerListState);
    const idx = oldList.findIndex(target => {
      return target.id === timeController.id;
    });
    if (idx !== -1) return;

    const unification = get(unificationMapTimeControllerState);
    unification.addTimeController(timeController);

    const newList = [...oldList, timeController];
    set(mapTimeControllerListState, newList);
  },
  get: () => {},
  dangerouslyAllowMutability: true
});

/**
 * 平面図タイムコントローラーリストからタイムコントローラーを削除する
 */
export const removeMapTimeControllerSelector = selector({
  key: 'removeMapTimeControllerSelector',
  set: ({get, set}, timeController) => {
    const unification = get(unificationMapTimeControllerState);
    unification.removeTimeController(timeController);

    const oldList = get(mapTimeControllerListState);
    const idx = oldList.findIndex(target => {
      return target.id === timeController.id;
    });
    if (idx === -1) return;

    const newList = [...oldList.slice(0, idx), ...oldList.slice(idx + 1)];
    set(mapTimeControllerListState, newList);
  },
  get: () => {},
  dangerouslyAllowMutability: true
});

export const mapTimeControllerWithID = selectorFamily({
  key: 'mapTimeControllerWithId',
  get: (id) => ({get}) => {
    const list = get(mapTimeControllerListState);
    const idx = list.findIndex(target => {
      return target.id === id;
    });
    if (idx === -1) return;
    return list[idx];
  },
  dangerouslyAllowMutability: true
});

export const isLastMapTimeController = selectorFamily({
  key: 'isLastMapTimeController',
  get: (id) => ({get}) => {
    const list = get(mapTimeControllerListState);
    const idx = list.findIndex(target => {
      return target.id === id;
    });
    if (idx === -1) {
      return false;
    }
    return idx === list.length -1;
  },
  dangerouslyAllowMutability: true
});

export const mapAutoRefreshState = atom({
  key: 'mapAutoRefreshState',
  default: true
})

export const mapAnimatingState  = atom({
  key: 'mapAnimatingState',
  default: false
})